import React from "react";
import 'react-phone-input-2/lib/material.css'
import {FastField} from 'formik';
import styles from './FormikPhoneInput.module.scss';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';
import PhoneInput from "react-phone-input-2";
import FormErrorDisplay from "../formErrorDisplay/FormErrorDisplay";
import classNames from "classnames";

interface IFormikPhoneInputProps {
  name: string;
  label: string | any;
  loading?: boolean;
}

const CustomizedTextField = (props: any) => {
  const touched = props.form.touched[props.field.name];
  const error = touched && props.form.errors[props.field.name];
  const valid = touched && !error;
  return <>
    <PhoneInput
      specialLabel={props.label}
      containerClass={classNames({
        [styles.container]: true,
        [styles.error]: !!error,
      })}
      country={'il'}
      value={props.field.value}
      masks={{il: '...-.......'}}
      placeholder={""}
      onChange={phone => {
        return props.field.onChange({
          target: {
            name: props.field.name,
            value: phone,
          },
        })
      }
      }
    />
    <FormErrorDisplay className={styles.errorDisplay} error={error}/>
  </>;
}
const FormikPhoneInput = ({loading, ...props}: IFormikPhoneInputProps) => loading ?
  (<SkeletonPlaceHolder
    className={styles.loadingField}
  >
    {props.label}
  </SkeletonPlaceHolder>) : (
    <FastField
      component={CustomizedTextField}
      required
      fullWidth
      variant="outlined"
      id={props.name}
      {...props}
    />
  );

FormikPhoneInput.defaultProps = {
  name: "",
  label: "",
  loading: false,
};

export default FormikPhoneInput;
